import { render, staticRenderFns } from "./DoughnutChartViewer.vue?vue&type=template&id=5a717f50&scoped=true&"
import script from "./DoughnutChartViewer.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a717f50",
  null
  
)

export default component.exports